import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ORDER_STATUS } from '../../../common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { CallIcon } = IMAGE_PATH;

const DeliveryInfo = ({ orderReducerData = {}, orderDetails = {}, isMobile = false }) => {
  const { deliveryPartner, store = {} } = orderReducerData;
  const { CREATED, ASSIGNED, PICKED_UP, OUT_FOR_DELIVERY, ARRIVED } = ORDER_STATUS;

  const checkOrderCreated = orderDetails?.status?.toUpperCase() === CREATED;
  const checkOrderIsOnTheWay =
    orderDetails?.status?.toUpperCase() === ASSIGNED ||
    orderDetails?.status?.toUpperCase() === PICKED_UP ||
    orderDetails?.status?.toUpperCase() === OUT_FOR_DELIVERY;
  const checkOrderArrived = orderDetails?.status?.toUpperCase() === ARRIVED;
  const orderNotCreated = orderDetails?.status?.toUpperCase() !== CREATED;

  return (
    <div className='delivery-info-daas'>
      <div className='info-content'>
        <div className='dis-flex-first'>
          <div className='left-sec head-text mr-set'>
            <span>{translateWithI18Next('contactKFC')}</span>
          </div>
          {deliveryPartner?.rider_phone && orderNotCreated && !isMobile && (
            <div className='rgt-sec algn-left mr-set mob-wid'>
              <span className='set-opacity'>{translateWithI18Next('contact')}</span>{' '}
              <strong>{deliveryPartner?.rider_name}</strong>
            </div>
          )}
          {isMobile && checkOrderIsOnTheWay && (
            <div className='rgt-sec algn-left mr-set mob-wid'>
              <strong>{deliveryPartner?.rider_name}</strong>{' '}
              <span className='set-opacity'>{translateWithI18Next('isOnTheWay')}</span>
            </div>
          )}
          {isMobile && checkOrderArrived && (
            <div className='rgt-sec algn-left mr-set mob-wid'>
              <strong>{deliveryPartner?.rider_name}</strong>
              <span className='set-opacity'>{translateWithI18Next('arrvingSoon')}</span>
            </div>
          )}
        </div>
        <div className='dis-flex-sec'>
          {checkOrderCreated && (
            <div className='left-sec mr-set created-driverstatus'>
              <span className='set-opacity'>{translateWithI18Next('findingDriver')}...</span>
            </div>
          )}

          {!isMobile && checkOrderIsOnTheWay && (
            <div className='left-sec mr-set'>
              <strong>{deliveryPartner?.rider_name}</strong>{' '}
              <span className='set-opacity'>{translateWithI18Next('isOnTheWay')}</span>
            </div>
          )}

          {!isMobile && checkOrderArrived && (
            <div className='left-sec mr-set'>
              <strong>{deliveryPartner?.rider_name}</strong>
              <span className='set-opacity'>{translateWithI18Next('arrvingSoon')}</span>
            </div>
          )}

          {isMobile && orderNotCreated && deliveryPartner?.rider_phone && (
            <div className='rgt-sec algn-left mr-set mob-wid'>
              <span className='set-opacity'>{translateWithI18Next('contact')}</span>{' '}
              <strong>{deliveryPartner?.rider_name}</strong>
            </div>
          )}

          {orderNotCreated && (
            <div className='rgt-sec algn-rgt mr-set'>
              {isMobile && (
                <>
                  <img src={CallIcon} alt=' ' />
                  <a href={'tel:' + deliveryPartner?.rider_phone} className='anchorTags'>
                    <span className='contact-text'>{translateWithI18Next('call')}</span>
                  </a>
                </>
              )}
              {!isMobile && <span className='contact-text-mob'>{deliveryPartner?.rider_phone}</span>}
            </div>
          )}
        </div>
        <div className='hr-line'></div>
        <div className='dis-flex-sec'>
          <div className='left-sec mr-set'>
            <span className='set-opacity'>{translateWithI18Next('kfcRestaraunt')}</span>
          </div>
        </div>
        <div className='dis-flex-sec'>
          <div className='left-sec mr-set'>
            <strong>{store?.name}</strong>
          </div>
          <div className='rgt-sec algn-rgt mr-set'>
            {isMobile && (
              <>
                <img src={CallIcon} alt=' ' />
                <a href={'tel:' + store?.phoneNumber} className='anchorTags'>
                  <span className='contact-text'>{translateWithI18Next('call')}</span>
                </a>
              </>
            )}
            {!isMobile && <span className='contact-text-mob'>{store?.phoneNumber}</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;
